import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
    name: 'shortNumber'
})
export class ShortNumberPipe implements PipeTransform {
    public transform(input?: number, args: number = 2): string {
        if (input === undefined || input === null || Number.isNaN(input) || !this.isNumeric(input)) {
            return '';
        }

        const suffixes: Array<string> = ['K', 'M', 'B', 'T', 'P', 'E'];
        const isNegative: boolean = input < 0;
        const absValue: number = Math.abs(input);
        const sign: string = isNegative ? '-' : '';

        if (absValue < 1000000) {
            if (environment.hasShortenedThousandRandValues) {
                return absValue < 1000
                    ? sign + absValue.toFixed(args)
                    : sign + (absValue / 1000).toFixed(args) + 'K';
            }
        } else if (environment.hasShortenedMillionAndGreaterRandValues) {
            const exp: number = Math.floor(Math.log(absValue) / Math.log(1000));
            const scaled: number = absValue / Math.pow(1000, exp);
            return sign + scaled.toFixed(args) + suffixes[exp - 1];
        }

        if (environment.hasCommaSeparatedThousands && absValue > 999 && absValue < 1000000) {
            return (isNegative ? '-' : '') + absValue.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: args
            });
        }

        let exp: number = 0;

        if (absValue >= 1000) {
            exp = Math.floor(Math.log(absValue) / Math.log(1000));
        } else {
            exp = 1; // force into K format even if < 1000
        }

        const scaled: number = absValue / Math.pow(1000, exp);
        const formatted: string = scaled.toFixed(args);
        const result: string = (isNegative ? '-' : '') + formatted + suffixes[exp - 1];

        return result;
    }

    public isNumeric(value: number | string): boolean {
        if (value < 0) {
            value = (value as number) * -1;
        }
        if (/^-{0,1}\d+$/.test(value as string)) {
            return true;
        } else return /^\d+\.\d+$/.test(value as string);
    }
}
